import api from '@/api'

export default class MemberApi {
	static async create(data) {
		return api.post('/member/make', data).then(function (response) {
			return response.data
		})
	}

	static async check(data) {
		return api.post('/member/check', data).then(function (response) {
			return response.data
		})
	}

	static async toBot(data) {
		return api.post('/member/to-bot', data).then(function (response) {
			return response.data
		})
	}

	static async share(data) {
		return api.post('/member/share', data).then(function (response) {
			return response.data
		})
	}

	static async buy(data) {
		return api.post('/member/buy', data).then(function (response) {
			return response.data
		})
	}

	static async get(data) {
		return api.post('/member/get', data).then(function (response) {
			return response.data
		})
	}
}
